<template>
  <layout
    :key="uniquePageKey"
    :header="header"
    :type="'business'"
    :footer="footer"
    :country="country"
    class="bg-white"
  >
    <business-banner
      id="business-banner"
      class="mb-14 sm:mb-16"
      :is-submitted="isSubmitted"
    />

    <div class="mx-auto w-full" :class="[isMobile ? '' : 'container']">
      <business-carousel
        :title="carouselTitle"
        :items="howItWorks"
        class="mb-14 mx-4"
      />

      <transition name="fade">
        <business-form
          v-if="!isSubmitted"
          id="request-order"
          :items="howItWorks"
          class="sm:mb-20 px-0 sm:px-18"
          @form-submitted="onFormSubmit"
        />
      </transition>
    </div>
  </layout>
</template>

<script>
import createPageMixin from '~/mixins/page'
import Layout from '~/components/layout/default'
import {
  BusinessBanner,
  BusinessCarousel,
  BusinessForm,
} from '~/components/organisms'

export default {
  components: {
    Layout,
    BusinessBanner,
    BusinessCarousel,
    BusinessForm,
  },
  mixins: [
    createPageMixin({
      pageType: 'business',
      cloudfrontCache: true,
    }),
  ],
  data() {
    return {
      metaTitle: 'B2B',
      isSubmitted: false,
      howItWorks: [
        {
          badge: '1',
          title: this.$t('business.how_it_works.step_1.title'),
          description: this.$t('business.how_it_works.step_1.description'),
        },
        {
          badge: '2',
          title: this.$t('business.how_it_works.step_2.title'),
          description: this.$t('business.how_it_works.step_2.description'),
        },
        {
          badge: '3',
          title: this.$t('business.how_it_works.step_3.title'),
          description: this.$t('business.how_it_works.step_3.description'),
        },
      ],
    }
  },
  computed: {
    isMobile() {
      return this.$mq === 'sm'
    },
    carouselTitle() {
      if (this.isSubmitted)
        return this.$t('business.how_it_works.title_whats_next')
      return this.$t('business.how_it_works.title_how_it_works')
    },
  },
  methods: {
    onFormSubmit() {
      this.isSubmitted = true
      this.howItWorks[0].badge = this.$t('business.how_it_works.badge_done')
      this.howItWorks[0].done = true
      this.$scrollTo('#business-banner', 1000)
    },
  },
}
</script>
